import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import httpClient from "@/tools/http-client";

export const useCoinsStore
    = defineStore('coinsStore', () => {

    const coinsEndpoint = environment.appConfig.baseApiUrl + "coins/data";
    const coinEndpoint = environment.appConfig.baseApiUrl + "coins/item";


    const crud = useCrudStore(coinsEndpoint);

    async function loadData(metaParams) {
        console.log("loadCoinsItems");
        crud.startLoading();
        try {
            const startPage = Number(metaParams.page || 0) + 1;
            const perPage = Number(metaParams.per_page || 20);
            metaParams.page = startPage;
            metaParams.per_page = perPage;

            const resp = await httpClient.get(coinsEndpoint, {params: metaParams});
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
           // console.log('loaded data',  resp.data.coins )
          //  console.log('loaded ', JSON.stringify(resp.data.coins, null, 2))
            crud.addItems(resp.data.coins);
            crud.clearLoading();
        } catch (e) {
            crud.setError(e);
        }
    }

    async function loadItem({coin_id}) {
        console.log("loadCoinItem");
        crud.startLoading();
        // Ищу, может уже есть с таким ID
        const found = crud.data?.find(item => item.id === coin_id);
        if(found) {
            crud.clearLoading();
            crud.setRecord(found);
            return;
        }
        try {
            const params = {coin_id};
            const resp = await httpClient.get(coinEndpoint, {params});
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.setRecord(resp.data.coin);
            crud.clearLoading();
        }catch (e) {
            crud.setError(e);
        }
    }
    return {
        ...crud,
        loadData,
        loadItem,
    }
});
